import axios from "axios";

const httpService = axios.create({
  baseURL: "https://api.logisticsaios.app", 
  headers: {
    "Content-Type": "application/json",
  },
});

export default httpService;
